import { render, staticRenderFns } from "./MdIcon.vue?vue&type=template&id=70b0f996&"
import script from "./MdIcon.vue?vue&type=script&lang=js&"
export * from "./MdIcon.vue?vue&type=script&lang=js&"
import style0 from "./MdIcon.vue?vue&type=style&index=0&id=70b0f996&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports